import { useState, useCallback } from 'react';
import { useNotification } from '../../../../contexts/NotificationContext';

export const usePostOpOrdersValidation = (formData) => {
  const { showNotification } = useNotification();
  const [errors, setErrors] = useState({});

  const validateField = useCallback((name, value) => {
    let error = "";
    switch (name) {
      case 'order_datetime':
        if (!value) error = "Order Date & Time is required";
        break;
      case 'doctor_name':
        if (!value) error = "Doctor Name is required";
        break;
      case 'doctor_name_signature':
        if (!value) error = "Doctor Signature is required";
        break;
      default:
        break;
    }
    setErrors((prev) => ({ ...prev, [name]: error }));
    return error === "";
  }, []);

  const validateForm = useCallback(() => {
    const requiredFields = [
      { key: 'order_datetime', label: 'Order Date & Time' },
      { key: 'doctor_name', label: 'Doctor Name' },
      { key: 'doctor_name_signature', label: 'Doctor Signature' },
    ];

    const tempErrors = {};
    requiredFields.forEach(({ key, label }) => {
      if (!formData[key] || String(formData[key]).trim() === '') {
        tempErrors[key] = `${label} is required`;
      }
    });

    setErrors(tempErrors);

    if (Object.keys(tempErrors).length > 0) {
      const firstKey = Object.keys(tempErrors)[0];
      const el = document.querySelector(`[name="${firstKey}"]`);
      if (el) { 
        el.scrollIntoView({ behavior: 'smooth', block: 'center' }); 
        el.focus(); 
      }
      showNotification('error', `Please fill in all required fields.`);
    }

    return Object.keys(tempErrors).length === 0;
  }, [formData, showNotification]);

  return { errors, setErrors, validateField, validateForm };
};
